export default __webpack_public_path__ + "static/media/phone.30800035.svg";